export default __webpack_public_path__ + "static/media/category.fe0e36d8.svg";